import http from "app/services/httpService";
import config from "config.json";

const { apiUrl } = config;

const getBookingHistory = async (query) => {
  const url = `${apiUrl}/flight/supplier-book-flight-all${
    query ? `?${query}` : ""
  }`;
  const data = await http.get(url);
  return data;
};
const getAirCalendar = async (query) => {
  const url = `${apiUrl}/Supplier/flight/passenger-calendar${
    query ? `?${query}` : ""
  }`;
  const data = await http.get(url);
  return data;
};
const ExportAirCalendar = async (queryString) => {
  try {
    const url = `${apiUrl}/Supplier/flight/passenger-calendar/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

// ExportBookingHistory = async (queryString) => {
//   const url = `${apiUrl}/flight/book-flight-all/export ${queryString ? `?${queryString}` : ""}`;
//   const data = await http.get(url);
//   return data;
// };
const ExportBookingHistory = async (queryString) => {
  try {
    const url = `${apiUrl}/Supplier/flight/book-flight-all/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const bookingDetails = async (id) => {
  //debugger;
  try {
    const { data } = await http.post(
      `${apiUrl}/Supplier/flight/booking-details/${id}`,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
const changeRequestDetails = async (query) => {
  const url = `${apiUrl}/Supplier/flight/booked-flight-change-request-list${
    query ? `?${query}` : ""
  }`;
  const data = await http.get(url);
  return data;
};
const approveRequestDetails = async (values) => {
  try {
    const { data } = await http.post(
      `${apiUrl}/Supplier/flight/approve-booking-request`,
      values,
    );
    // console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};
const declineRequestDetails = async (values) => {
  try {
    const { data } = await http.post(
      `${apiUrl}/Supplier/flight/decline-booking-request`,
      values,
    );
    // console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};

export {
  getBookingHistory,
  getAirCalendar,
  ExportBookingHistory,
  bookingDetails,
  changeRequestDetails,
  approveRequestDetails,
  declineRequestDetails,
  ExportAirCalendar,
};
